// extracted by mini-css-extract-plugin
export var tag = "AnchorTag-module--tag--FZk9F";